import colors from '../theme/colors';

// const A4_96 = {
//   width: 794,
//   height: 1123
// };
// const A4_150 = {
//   width: 1240,
//   height: 1754
// };
const WIDE_SCREEN = {
  width: 1920,
  height: 1080
};

const VocationOneTheme = {
  size: {
    ...WIDE_SCREEN
    // maxCodePaneHeight: 200
  },
  colors: {
    // primary: '#ebe5da',
    // secondary: '#fc6986',
    // // tertiary: '#1e2852',
    // quaternary: '#ffc951',
    // quinary: '#8bddfd'
    ...colors,
    primary: colors.blue,
    secondary: colors.grey,
    success: colors.green,
    danger: colors.red,
    warning: colors.yellow,
    textColor: '#43464d',
    darkBackground: '#1d1e20',
    greyBackground: '#2d2d2d',
    brandColor: '#009fe3',
    brandSolid: '#0076e3',
    itemBackground: 'rgba(0, 0, 0, 0.06)',
    itemBackgroundHover: 'rgba(0, 0, 0, 0.11)'
  },
  fonts: {
    header: '"Montserrat", sans-serif',
    text: '"Montserrat", sans-serif',
    monospace: '"Consolas", "Menlo", monospace'
  },
  fontSizes: {
    h1: '72px',
    h2: '64px',
    h3: '56px',
    text: '44px',
    monospace: '20px'
  },
  // space: [16, 24, 32],
  space: [0, 0, 0]
};

export default VocationOneTheme;
